import React, { useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import { EditVacancyDetails, GetCompaniesList, GetPositionsList, GetVacancy } from '../services/httpServices';

const EditVacancy = (props) => {
  let { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [selectedJobShift, setSelectedJobShift] = useState({});
  const [selectedVacancyType, setSelectedVacancyType] = useState({});
  const [selectedPosition, setSelectedPosition] = useState({});
  const [selectedEmploymentType, setSelectedEmploymentType] = useState({});
  const [positionsList, setPositionsList] = useState([]);
  const [vacancy, setVacancy] = useState({});
  const [companiesList, setCompaniesList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const vacancyNameRef = useRef('');

  const salaryRangeRef = useRef('');

  const numberOfVacancyRef = useRef('');
  const countryOfOriginRef = useRef('');
  const remarksRef = useRef('');
  const descriptionRef = useRef('');
  const joiningDateRef = useRef('');

  const jobShift = [{ value: 'Morning' }, { value: 'Evening' }, { value: 'Night' }];
  const vacancyType = [{ value: 'New Vacancy' }, { value: 'Replacement Vacancy' }];
  const employmentType = [{ value: 'Regular' }, { value: 'Contractual' }];
  const fetch = async (event) => {
    const savedVacancy = await GetVacancy(id);
    const positions = await GetPositionsList();
    setVacancy(savedVacancy);
    setPositionsList(positions);

    setSelectedVacancyType(vacancyType?.find((e) => e.value == savedVacancy?.vacancyType));
    setSelectedPosition(positions?.find((e) => e.id == savedVacancy?.positionId));
    setSelectedEmploymentType(employmentType?.find((e) => e.value == savedVacancy?.employmentType));
    setSelectedJobShift(jobShift?.find((e) => e.value == savedVacancy?.shift));

    setLoading(false);
    const companies = await GetCompaniesList();
    setSelectedCompany(companies?.find((e) => e.id == savedVacancy?.mstCompanyId));
    setCompaniesList(companies);
  };
  useEffect(() => {
    fetch();
  }, []);

  const SaveUser = async (event) => {
    // setPosting(true);
    event.preventDefault();
    //  console.log('saveHit');
    const payload = {
      id: id,
      vacancyName: vacancyNameRef.current.value,
      vacancyType: selectedVacancyType?.value,
      noOfVac: numberOfVacancyRef.current.value,
      location: countryOfOriginRef.current.value,
      salaryRange: salaryRangeRef.current.value,
      shift: selectedJobShift?.value,
      description: descriptionRef.current.value,
      employmentType: selectedEmploymentType?.value,
      remarks: remarksRef.current.value,
      startDate: joiningDateRef?.current.value,
      positionId: selectedPosition?.id,
      positionName: selectedPosition?.name,
      mstCompanyName: selectedCompany?.companyName,
      mstCompanyId: selectedCompany?.id,
    };

    let response = await EditVacancyDetails(payload);

    if (response.status == 200) {
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Edit Job | Immigration System </title>
      </Helmet>
      <Container>
        <form onSubmit={SaveUser}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              {vacancy?.vacancyName}
            </Typography>

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Vacancy Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.vacancyName}
                        inputRef={vacancyNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="role"
                        size="small"
                        options={vacancyType}
                        defaultValue={vacancyType?.find((e) => e.value == vacancy?.vacancyType)}
                        getOptionLabel={(shift) => shift.value}
                        renderInput={(params) => (
                          <TextField required {...params} label="Vacancy Type" variant="outlined" />
                        )}
                        onChange={(event, vacancyType) => setSelectedVacancyType(vacancyType)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="position"
                        size="small"
                        options={positionsList}
                        defaultValue={positionsList?.find((e) => e.id == vacancy?.positionId)}
                        getOptionLabel={(position) => position.name}
                        renderInput={(params) => <TextField required {...params} label="Position" variant="outlined" />}
                        onChange={(event, position) => setSelectedPosition(position)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Number of Open Positions"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.noOfVac}
                        inputRef={numberOfVacancyRef}
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <Autocomplete
                        id="employers"
                        size="small"
                        options={companiesList}
                        value={selectedCompany}
                        // defaultValue={companiesList?.find((e) => e.id == vacancy?.mstCompanyId)}
                        getOptionLabel={(company) => company.companyName}
                        renderInput={(params) => <TextField required {...params} label="Employer" variant="outlined" />}
                        onChange={(event, company) => setSelectedCompany(company)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="EmploymentType"
                        size="small"
                        options={employmentType}
                        defaultValue={employmentType?.find((e) => e.value == vacancy?.employmentType)}
                        getOptionLabel={(employmentType) => employmentType.value}
                        renderInput={(params) => (
                          <TextField required {...params} label="Employment Type" variant="outlined" />
                        )}
                        onChange={(event, employmentType) => setSelectedEmploymentType(employmentType)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Salary Range"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.salaryRange}
                        inputRef={salaryRangeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Joining Date"
                        required
                        type="date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.startDate?.split('T')[0]}
                        InputLabelProps={{ shrink: true }}
                        inputRef={joiningDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Origin"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.location}
                        inputRef={countryOfOriginRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <TextField
                        label="Remarks"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={vacancy?.remarks}
                        inputRef={remarksRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={12}>
                      <TextField
                        label="Description"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                        defaultValue={vacancy?.description}
                        inputRef={descriptionRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
      </Container>
    </>
  );
};

export default EditVacancy;
